import { VetClientModel } from "../../../../../../models/vetting/vetting.models";
import { computedFrom } from "aurelia-binding";
import { autoinject, useView } from "aurelia-framework";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";

@autoinject
@useView('views/pages/modules/vetting/drawer/tabs/vet-details.html')
export class VetDetails {

    public showSTS: boolean = false;
    public showTC: boolean = false;
    public showBerthInVetRequest: boolean = false;
    public item: VetClientModel;

    constructor(private userClaimsService: UserClaimsService)
    {
        this.showSTS = this.userClaimsService.hasPermission(Claims.ShowShipToShip);
        this.showTC = this.userClaimsService.hasPermission(Claims.ShowCharterType);
        this.showBerthInVetRequest = this.userClaimsService.hasPermission(Claims.ShowBerthInVetRequest);
    }

    activate(vet: VetClientModel) {
        this.item = vet;
    }
    
    @computedFrom("item", "item.initialEmailsForCorrespondence", "item.initialEmailsForCorrespondence.length")
    get correspondenceEmails() {
        if(this.item.initialEmailsForCorrespondence)
            return this.item.initialEmailsForCorrespondence.filter(x => !x.isShipManagerEmail);
        return [];
    }

    @computedFrom("item", "item.initialEmailsForCorrespondence", "item.initialEmailsForCorrespondence.length")
    get shipManagerEmails() {
        if(this.item.initialEmailsForCorrespondence)
            return this.item.initialEmailsForCorrespondence.filter(x => x.isShipManagerEmail);
        return [];
    }

    @computedFrom("item", "item.vetForSTS")
    get vetForSTSValue(): string {
        if (this.item.vetForSTS == undefined || this.item.vetForSTS == null) {
            return '';
        }
        else if (this.item.vetForSTS) {
            return 'Yes'
        }
        else {
            return 'No'
        }
    }

    @computedFrom("item", "item.transactionNumber")
    get transactionNumber(): string {
        if (this.item.transactionNumber == null) {
            return 'N/A';
        }
        return this.item.transactionNumber;
    }
}
